export type FeedbackScreenshotCapture = () => Promise<string>;

let activeCapture: FeedbackScreenshotCapture | null = null;

export const registerFeedbackScreenshotCapture = (
	capture: FeedbackScreenshotCapture,
): (() => void) => {
	activeCapture = capture;
	return () => {
		if (activeCapture === capture) activeCapture = null;
	};
};

export const captureFeedbackScreenshot = async (): Promise<string | null> => {
	try {
		return activeCapture ? await activeCapture() : null;
	} catch {
		return null;
	}
};

export const optimizeFeedbackScreenshot = async (dataUrl: string): Promise<string> => {
	if (!dataUrl.startsWith("data:image/png;base64,") || dataUrl.length < 10 * 1024 * 1024) {
		return dataUrl;
	}
	try {
		const image = new Image();
		image.src = dataUrl;
		await image.decode();
		const canvas = document.createElement("canvas");
		canvas.width = image.naturalWidth;
		canvas.height = image.naturalHeight;
		const context = canvas.getContext("2d");
		if (!context) return dataUrl;
		context.drawImage(image, 0, 0);
		const webp = canvas.toDataURL("image/webp", 0.92);
		return webp.startsWith("data:image/webp;base64,") && webp.length < dataUrl.length
			? webp
			: dataUrl;
	} catch {
		return dataUrl;
	}
};

export const feedbackScreenshotName = (dataUrl: string): string =>
	dataUrl.startsWith("data:image/webp;base64,") ? "match-screenshot.webp" : "match-screenshot.png";
